export default __webpack_public_path__ + "static/media/bottomCenter.1d1008c0.svg";